import type { DocForLinking } from './docForLinkingType';
import { riskLevelFromRisk } from '../../../models/risk';
import { pageIds } from '../pages/pageIds';

export function getDocForLinking(
  item: any,
  type: string,
  organizationId: number,
  pageId: number,
  userId: string,
  parentHref: string,
): DocForLinking {
  if (item.pages?.length) {
    pageId = item.pages[0];
    if (pageId === 279) {
      pageId = pageIds.riskAssessments;
    }
  }
  let classes = '';
  if (type === 'riskAssessments') {
    const calculatedRisk = (item.consequence ?? 0) * (item.probability ?? 0);
    if (calculatedRisk) {
      classes = 'risk' + riskLevelFromRisk(calculatedRisk);
    }
  }
  let noAccess = false;
  let classified = false;
  let href = '/account/' + organizationId + '/' + pageId + '/' + parentHref + type + '/' + item.uuid;
  if (item.classification && item.classification !== 'NONE') {
    classified = true;
    if (!item.accessControl?.includes(userId + '')) {
      noAccess = true;
      href = 'restricted';
    }
  }
  return {
    templateId: item.mainTemplateId ?? undefined,
    uuid: item.uuid,
    docType: type,
    classes,
    classified,
    noAccess,
    href,
    name: item.name,
    dateTimeForOrdering: '',
  };
}
